import React, { forwardRef } from 'react';

const AccessibleButton = forwardRef(({
    children,
    variant = 'primary',
    size = 'md',
    loading = false,
    disabled = false,
    ariaLabel,
    className = '',
    ...props
}, ref) => {
    const variants = {
        primary: 'btn-primary',
        secondary: 'btn-secondary',
        outline: 'btn-secondary',
        ghost: 'btn-ghost',
        danger: 'btn-danger',
        success: 'btn-primary'
    };

    const sizes = {
        sm: '!min-h-[36px] !px-3 !py-1.5 !text-xs',
        md: '',
        lg: '!min-h-[48px] !px-6 !text-base'
    };

    return (
        <button
            ref={ref}
            className={`${variants[variant] || variants.primary} ${sizes[size] || ''} ${className}`}
            disabled={disabled || loading}
            aria-label={ariaLabel}
            aria-busy={loading}
            {...props}
        >
            {loading && (
                <svg
                    className="animate-spin -ml-0.5 mr-2 h-4 w-4 text-current"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                </svg>
            )}
            {children}
        </button>
    );
});

AccessibleButton.displayName = 'AccessibleButton';

export default AccessibleButton;
